import React from "react";
import { BasePanel } from "./BasePanel";
import { Season } from "../../types";
import { 
  createSeason, 
  deleteSeason, 
  getListSeasons, 
  updateSeason 
} from "../../api";

export const SeasonPanel: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const defaultStartDate = new Date(currentYear, 8, 1).toLocaleDateString("en-CA").slice(0, 10);
  const defaultEndDate = new Date(currentYear + 1, 5, 30).toLocaleDateString("en-CA").slice(0, 10);
  return (
    <BasePanel<Season>
      config={{
        title: "Stagioni",
        elementName: "Stagione",
        getItems: () => getListSeasons(),
        createItem: (data) => createSeason(data),
        updateItem: (id, data) => updateSeason(id, data),
        deleteItem: (id) => deleteSeason(id),
        renderItem: (item) => (
          <div className="py-2 flex flex-col sm:flex-row sm:justify-between sm:items-center">
            <span className="text-sm sm:text-base font-medium mb-1 sm:mb-0 lg:min-w-[400px]">
              {item.name} {item.is_active ? "(Attiva)" : ""}
            </span>
            <span className="text-sm sm:text-base font-medium mb-2 sm:mb-0">
              Max punti totali (default): {item.default_tournament_points}pt
            </span>
          </div>
        ),
        getTextField: (item) => item.name,
        fields: [
          { name: "start_date", label: "Data Inizio", type: "date", required: true , defaultValue: defaultStartDate },
          { name: "end_date", label: "Data Fine", type: "date", required: true , defaultValue: defaultEndDate },
          { name: "default_tournament_points", label: "Default Max Punti Tornei", type: "number", required: true, defaultValue: 120 },
        ],
      }}
    />
  )
}